import React from 'react';

import CardDialog from '~/components/CardDialog';
import { useClaim } from '~/components/ClaimContainer';
import DialogFooterActions from '~/components/core/DialogFooterActions';
import DocumentsContainer from '~/components/Documents/DocumentsContainer';
import type { ClaimDocument } from '~/components/types/claim-document-types';

interface ChatContextDocumentsDialogProps {
  open: boolean;
  onClose: () => void;
  onAddToChat: (selectedIds: number[]) => void;
  documentIds: number[];
}

export const ChatContextDocumentsDialog: React.FC<ChatContextDocumentsDialogProps> = ({
  open,
  onClose,
  onAddToChat,
  documentIds,
}) => {
  const { claim } = useClaim();
  const [selectedDocumentIds, setSelectedDocumentIds] = React.useState<number[]>(documentIds);

  const shouldDisableRow = (document: ClaimDocument): { disable: boolean; tooltip?: string } | null => {
    if (document.is_processed_by_ai) return null;
    return { disable: true, tooltip: 'Clive analysis is not yet available for this document.' };
  };

  return (
    <CardDialog
      title="Add Documents to Chat"
      isDialog
      open={open}
      fullWidth
      maxWidth="lg"
      onClose={() => {
        setSelectedDocumentIds([]);
        onClose();
      }}
      footerActions={
        <DialogFooterActions
          onClickPrimary={() => onAddToChat(selectedDocumentIds)}
          onClickSecondary={onClose}
          primaryLabel="Add to Chat"
          showPrimary
          secondaryLabel="Cancel"
          ignorePermissionsSecondary
        />
      }
    >
      <DocumentsContainer
        claim={claim}
        classes={{}}
        newDocumentDefaultType="damage_estimate"
        selectedDocumentIds={selectedDocumentIds}
        onDocumentsClick={(ids: number[]) => setSelectedDocumentIds(ids as number[])}
        selectOnly
        autoPaginateRowsPerPage={25}
        shouldDisableRow={shouldDisableRow}
        showAddToChat={false}
        withCliveStatus
      />
    </CardDialog>
  );
};
